import styled from 'styled-components';
import animatedSuccess from './assets/animated_success.gif';

export const AnimatedSuccess = styled.div`
    width: 143px;
    height: 100px;
    background: url("${animatedSuccess}") center center no-repeat;
    background-size: contain;
`;
